module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-31.45ce3fb3.svg";